import { Component } from '@angular/core';
import { IntroTwoComponent } from './intro-two.component';

@Component({
  selector: 'eid-intro-two-mobile',
  templateUrl: './intro-two.mobile.component.html',
  styleUrls: ['./intro-two.mobile.component.scss']
})
export class IntroTwoMobileComponent extends IntroTwoComponent {}
